<div fxLayout="column" fxFlexFill *ngIf="!loader">

  <div class="divider layout-padd-2" *ngIf="currMerchant" ngClass.xs="layout-padd" fxLayoutAlign="start center"
    fxLayoutGap="10px">

    <button mat-icon-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div fxLayout="column">
      <span class="mat-title">{{currMerchant.denomination | capitalize | descFilter: 20}}</span>
      <span class="mat-title boldest">{{'noteComponent.transacHist'|translate}}</span>
    </div>

  </div>
  <!-- *ngIf="!currMerchant" -->
  <div class="divider layout-padd-2 title-filter-date"  ngClass.xs="layout-padd-5" #pageTitle>
    <span class="mat-title">{{'noteComponent.tickets'|translate}}</span>
    <div fxLayoutAlign="center center" class="filter-date-vignette primary clicked"
      (click)="setFilteranim()" fxHide fxShow.xs>
      <i class="material-icons" *ngIf="!filterDateAnimFlag" style="color:white;">date_range</i>
      <i class="material-icons" *ngIf="filterDateAnimFlag" style="color:white;">keyboard_arrow_up</i>
    </div>

  </div>

  <div class="divider layout-padd-2" fxHide.xs>
    <app-filter-date-from-to [type]="'notes'" [merchant]="currMerchant" (setDataEvent)="setNotes($event)"
      (setLoaderEvent)='setNoteLoader($event)'>
    </app-filter-date-from-to>
  </div>

  <div [@toggleFilterDate]="getToggleFilterDate" class="cont-filter-date-fix" [ngStyle]="{'top.px': titlePositionTop}"
    fxHide fxShow.xs>
    <div class="layout-padd-2">
      <app-filter-date-from-to [type]="'notes'" (setDataEvent)="setNotes($event)"
        (setLoaderEvent)='setNoteLoader($event)'>
      </app-filter-date-from-to>
    </div>
  </div>

  <div fxFlex class="scrolled">

    <div class="scrolled-y">

      <table mat-table [dataSource]="dataSource" class="full-w clicked" ngClass.xs="fix-w-table" matSort>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'noteComponent.create'|translate}} </th>
          <td mat-cell *matCellDef="let note">
            {{note.date | dateFilter:"DD-MM-YYYY"}} | {{note.date | dateFilter:"HH:mm"}} </td>
        </ng-container>

        <ng-container matColumnDef="user_denomination">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'noteComponent.merchant'|translate}}  </th>
          <td mat-cell *matCellDef="let note"> {{note.user_denomination | uppercase}} </td>
        </ng-container>

        <ng-container matColumnDef="point_of_sale_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'noteComponent.point_of_sales'|translate}}  </th>
          <td mat-cell *matCellDef="let note"> {{note.point_of_sale_name | uppercase}} </td>
        </ng-container>

        <ng-container matColumnDef="sale_method_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'noteComponent.saleMethod'|translate}}  </th>
          <td mat-cell *matCellDef="let note"> {{note.sale_method_name | uppercase}} </td>
        </ng-container>

        <ng-container matColumnDef="total_ttc">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'noteComponent.totalprod'|translate}}  </th>
          <td mat-cell *matCellDef="let note"> {{note.total_ttc}} </td>
        </ng-container>

        <ng-container matColumnDef="print" stickyEnd>
          <th mat-header-cell *matHeaderCellDef> </th>
          <td mat-cell *matCellDef="let note">
            <div fxLayoutAlign="center center">
            
                <mat-icon class="great-ico clicked" matTooltip="{{'fidelityComponent.print'|translate}}" matTooltipPosition="below"
                (click)="goPrintTicket(note.print)" angulartics2On="click"
                angularticsAction="openPrintNote" angularticsCategory="clientNotes">print</mat-icon>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <div fxLayoutAlign="center center" class="layout-padd"
        *ngIf="!noteLoader && !loader && dataSource.data.length < 1">
        <span class="mat-subheading-1">{{'noteComponent.noTicket'|translate}}</span>
      </div>

      <app-popup-loader [flagLoading]="noteLoader" [size]="30" [statusMessage]="'noteComponent.messageLoaderGetTicket'|translate"
        [type]="'line'">
      </app-popup-loader>

    </div>

    <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>

  </div>

</div>

<app-popup-loader [flagLoading]="loader" [size]="30" [statusMessage]="'noteComponent.messageLoaderGetTicket'|translate">
</app-popup-loader>
